// eventBus.js
import Vue from 'vue';
export const EventBus = new Vue();

export const globalEmitter = (event, data) => {
  EventBus.$emit(event, data);
}